import React from "react";   
import RouteFreightTableDefaultListPageContainer from "./RouteFreightTableDefaultListPageContainer";

export class RouteFreightTableDefaultListPage extends React.Component {
  render() {
    return <RouteFreightTableDefaultListPageContainer {...this.props} />;
  }
}
